import { defineComponent } from "vue";
import InputBaseControl from "./InputBaseControl";

export default defineComponent({
  name: "Date",
  extends: InputBaseControl,
  data() {
    // TODO prerobit do baseControl;
    return {
      inputValues: {
        day: "",
        month: "",
        year: "",
      },
    };
  },
  computed: {
    getYear(): string {
      return this.inputValues.year.startsWith("0") ? this.inputValues.year.substring(0, 1) : this.inputValues.year;
    },
    getMonth(): string {
      return this.inputValues.month.startsWith("0") ? this.inputValues.month.substring(0, 1) : this.inputValues.month;
    },
    getDay(): string {
      return this.inputValues.day.startsWith("0") ? this.inputValues.day.substring(0, 1) : this.inputValues.day;
    },
  },
  methods: {
    reset(silent: boolean = true) {
      this.inputValues.year = "";
      this.inputValues.month = "";
      this.inputValues.day = "";
      this.setValue(this.defaultState.value ? this.defaultState.value : "", silent);
      this.config.editedParentRowNumber = null;
      this.resetErrors();
    },
    getValue() {
      const defaultFormat = window.FormEngine.engineConfig.builder.components?.Date?.defaultFormat;

      const year: string = this.dateNumString(this.inputValues.year);
      const month: string = this.dateNumString(this.inputValues.month);
      const day: string = this.dateNumString(this.inputValues.day);

      const isValidDate = this.isValidDate(year, month, day);

      let result: string = "";

      // Return value only if all input data and date format is valid
      if (isValidDate) {
        if (defaultFormat) {
          result = defaultFormat(year, month, day);
        } else {
          result = this.formatDate(year, month, day);
        }
      } else {
        this.inputValues.year = "";
        this.inputValues.month = "";
        this.inputValues.day = "";
      }
      return result;
    },
    setValue(value: string, silent: boolean = false) {
      let dateParts = value.split("-");

      this.state.value = value;
      this.state.silentSetValue = silent;
      if (dateParts[0]) this.inputValues.year = dateParts[0];
      if (dateParts[1]) this.inputValues.month = dateParts[1];
      if (dateParts[2]) this.inputValues.day = dateParts[2];
    },
    formatDate(year: string, month: string, day: string): string {
      return year + "-" + (month.length < 2 ? "0" + month : month) + "-" + (day.length < 2 ? "0" + day : day);
    },
    dateNumString(input: string): string {
      const numericRegex = /^\d+$/;

      if (!input || !numericRegex.test(input)) {
        return "";
      }

      return input.toString();
    },
    isValidDate(y: string, m: string, d: string): boolean {
      let year = Number(y);
      let month = Number(m);
      let day = Number(d);

      if (!year && !month && !day) {
        return false;
      }

      const date = new Date();
      date.setFullYear(year);
      date.setMonth(month - 1);
      date.setDate(day);

      return date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;
    },
  },
});
